import { useEffect, useState } from "react";
import { Backdrop, Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { AxiosResponse } from "axios";
import http from "../../../utils/http";
import CountCard from "./CountCard";
import { errorToastMessage } from "../../../utils/toast";
import { CountCards } from "../DashboardContent/dashboard";
import Loader from "../../Common/assets/Loader";
import StudyDetails from "./StudyDetails";
import { DateTime } from "luxon";

const PlatformDashboard = () => {
  const { id: studyId } = useParams();
  const [loading, setLoading] = useState(true);
  const [cardData, setCardData] = useState<any>(null);
  const [studyDetails, setStudyDetails] = useState<any[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const res: AxiosResponse = await http.get(
          `/platform/users/global-dashboard`
        );
        const apiRes = res.data.data;

        const cardData = CountCards.map((card: any) => {
          return {
            ...card,
            value: apiRes?.globalCounts?.[card.key] || 0,
          };
        });

        setCardData(cardData);
        const newData = apiRes?.studyList?.map((item: any) => ({
          id: item?.id,
          studyName: item?.name,
          participants: item?.total_participants,
          startDate: item?.created_at
            ? DateTime.fromISO(item?.created_at).toFormat("MM/dd/yyyy")
            : "",
          status: item?.status || "-",
          endDate: item?.closed_on
            ? DateTime.fromISO(item?.closed_on).toFormat("MM/dd/yyyy")
            : "",
        }));
        setStudyDetails(newData);

        setLoading(false);
      } catch (err) {
        errorToastMessage(err as Error);
        setLoading(false);
      }
    };
    fetchData();
  }, [studyId]);

  return (
    <>
      {loading ? (
        <Backdrop
          open={true}
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        >
          <Loader />
        </Backdrop>
      ) : (
        <>
          <Box sx={{ height: "100%", overflow: "auto", p: 2 }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                gridGap: "16px",
                width: "100%",
                mb: 2,
              }}
            >
              {cardData?.map((item: any) => (
                <Box key={item?.key}>
                  <CountCard data={item} />
                </Box>
              ))}
            </Box>
            <StudyDetails data={studyDetails} />
          </Box>
        </>
      )}
    </>
  );
};

export default PlatformDashboard;
